import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { logoutBuyer } from "../redux/tokenSlice";
import "./header.css";
import logo from "../assets/larerhack.svg";
import { removeItem } from "../redux/cartListSlice";
import axios from "axios";
import { resetCategory } from "../redux/categorySlice";
import HomeDropdown from "./HomeDropdown";
import { toast } from "react-toastify";
import "../assets/ReactToastify.css";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Collapse } from "bootstrap";

const notify = () => {
  toast.info(
    "This was added only for design purposes, no functionalities included.",
    {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  );
};

export default function Header() {
  const [cartItemsData, setCartItemsData] = useState([]);

  const dispatch = useDispatch();
  /* const buyer = useSelector((state) => {
    return state.buyer;
  }); */
  const token = useSelector((state) => {
    return state.token;
  });
  const cartItems = useSelector((state) => state.cartList);

  const tokenBearer = token.token;

  const navigate = useNavigate();

  const handleLogout = async (e) => {
    e.preventDefault();
    dispatch(logoutBuyer());
    toast.success("You were successfully logged out", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    navigate("/");
  };

  const handleCategoryReset = async (e) => {
    e.preventDefault();
    dispatch(resetCategory());
    navigate("/catalog");
  };

  const getAndSetItemsData = async (cartItems) => {
    const itemsData = [];

    if (!cartItems.length) {
      setCartItemsData([]);
      return;
    }

    for (const item of cartItems) {
      try {
        if (!item.slug) continue;

        const data = await axios

          // TODO: env variables
          .get(`${process.env.REACT_APP_API_URL}/products/` + item.slug)
          .then((res) => res.data);

        if (!data) continue;

        itemsData.push({ ...data, quantity: item.quantity });
      } catch (err) {
        console.log(err);
      }
    }
    // console.log(itemsData);
    setCartItemsData(itemsData);
  };

  const handleOnItemRemove = (slug) => {
    // console.log(slug);
    dispatch(removeItem({ slug }));
  };

  useEffect(() => {
    getAndSetItemsData(cartItems);
  }, []);

  useEffect(() => {
    getAndSetItemsData(cartItems);
  }, [cartItems]);

  const showLogModal = useSelector((state) => {
    return state.showLogModal;
  });

  const handleReset = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/reset`
      );
      toast.success("Reseting DB.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      console.log(response);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <header className="header navbar-area">
      <div
        id={`topbar-div ${tokenBearer ? "" : "py-3"} `}
        className="topbar wow fadeInRight"
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 col-md-3 col-12 d-flex justify-content-start">
              <div id="stores-div" className="nav-social ">
                <Link to="#">
                  <i
                    id="gps"
                    className="fa-solid fa-location-dot"
                    onClick={notify}
                  ></i>
                  <h5 className="h5  title ms-2 mb-0" onClick={notify}>
                    Stores
                  </h5>
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-3 col-12"></div>
            <div className="col-lg-5 col-md-6 col-12 d-flex justify-content-end p-0 m-0">
              <div className="top-end">
                <div className="row d-flex align-items-center justify-content-end user">
                  <div className="col p-0">
                    <i className="fa-regular fa-user "></i>
                  </div>
                  <div className="col p-0">
                    <NavDropdown
                      id="nav-dropdown-dark-example"
                      // title="Dropdown"
                      menuVariant="dark"
                      className="p-0"
                    >
                      <NavDropdown.Item
                        className="text-decoration-none"
                        onClick={notify}
                      >
                        Reset DB
                      </NavDropdown.Item>
                      {tokenBearer && (
                        <>
                          <NavDropdown.Item>
                            <Link className="text-decoration-none" to="/orders">
                              Orders
                            </Link>
                          </NavDropdown.Item>

                          <NavDropdown.Item>
                            <Link
                              className="text-decoration-none"
                              to="password"
                            >
                              Reset Password
                            </Link>
                          </NavDropdown.Item>
                          <NavDropdown.Item>
                            <Link
                              className="text-decoration-none"
                              onClick={(e) => {
                                handleLogout(e);
                              }}
                              to="/"
                            >
                              Logout
                            </Link>
                          </NavDropdown.Item>
                        </>
                      )}
                    </NavDropdown>
                  </div>
                  <div className="col p-0">
                    <ul className="user-login mb-0 ps-2">
                      {!tokenBearer && (
                        <>
                          <li>
                            <Link
                              className="text-decoration-none"
                              to="/register"
                            >
                              Register
                            </Link>
                          </li>
                          <li>
                            <Link className="text-decoration-none" to="/login">
                              Login
                            </Link>
                          </li>
                        </>
                      )}

                      {tokenBearer && (
                        <>
                          {/* <li>
                        <Link className="text-decoration-none" to="/password">
                          Reset password
                        </Link>
                      </li> */}
                          {/* <li>
                        <Link
                          className="text-decoration-none"
                          onClick={(e) => {
                            handleLogout(e);
                          }}
                          to="/"
                        >
                          Logout
                        </Link>
                      </li> */}
                          {/* <li>
                        <a
                          className="text-decoration-none"
                          href="https://laderhack-admin.vercel.app"
                        >
                          Admin
                        </a>
                      </li> */}
                        </>
                      )}
                      <li>
                        <a
                          className="text-decoration-none"
                          //TODO: Change to new URL
                          href="https://laderhack-admin-ha.vercel.app"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Admin
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="bottom-header" className="header-middle wow fadeInLeft">
        <div className="container">
          <div className="row d-flex justify-content-between align-items-center">
            <div className="col-xxl-2 col-xl-4 col-lg-4 col-md-6 col-7 d-flex justify-content-start">
              <HomeDropdown handleCategoryReset={handleCategoryReset} />
              <Link className="navbar-brand" to="/">
                <img id="logo" src={logo} alt="Logo" />
              </Link>
            </div>

            <div id="links-header-div" className="col-lg-4 col-md-2 col-5 px-0">
              <div className="middle-center ms-auto">
                <ul
                  id="useful-links"
                  className="useful-links d-flex justify-content-center p-0 mb-0"
                >
                  <li>
                    <Link className="text-decoration-none" to="/">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={(e) => {
                        handleCategoryReset(e);
                      }}
                      className="text-decoration-none ms-3"
                      to="/catalog"
                    >
                      All Products
                    </Link>
                  </li>
                  <li className="mx-3">
                    <Link
                      className="text-decoration-none    rounded-2 text-small px-2"
                      to="/about-project"
                    >
                      About Project
                    </Link>
                  </li>
                  <li>
                    <Link className="text-decoration-none" to="/contact">
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-5 col-lg-8 col-md-2 col-5 d-flex justify-content-end">
              <div className="main-menu-search w-100">
                <div id="search-div" className="navbar-search search-style-5 ">
                  <div className="search-input">
                    <input type="text" placeholder="Search" />
                  </div>
                  <div className="search-btn">
                    <button id="search-button" onClick={notify}>
                      <i
                        id="search-button"
                        className="fa-solid fa-magnifying-glass"
                      ></i>
                    </button>
                  </div>
                </div>
              </div>

              <div className="middle-right-area">
                <div className="navbar-cart">
                  <div className="wishlist">
                    <Link className="background-black main-btn" to="#">
                      <i
                        onClick={notify}
                        id="heart-icon"
                        className="fa-solid fa-heart"
                      ></i>
                      <span className="total-items" onClick={notify}>
                        0
                      </span>
                    </Link>
                  </div>
                  <div className="cart-items">
                    <Link className="main-btn background-black" to="#">
                      <i className="fa-solid fa-cart-shopping"></i>
                      <span className="total-items">
                        {cartItems.reduce(
                          (prev, cur) => prev + Number(cur.quantity),
                          0
                        )}
                      </span>
                    </Link>

                    <div className="shopping-item">
                      <div className="dropdown-cart-header">
                        <span>
                          {cartItems.reduce(
                            (prev, cur) => prev + Number(cur.quantity),
                            0
                          )}{" "}
                          {cartItems.reduce(
                            (prev, cur) => prev + Number(cur.quantity),
                            0
                          ) === 1
                            ? "Item"
                            : "Items"}
                        </span>
                        <Link
                          id="view-cart"
                          className="text-decoration-none"
                          to="/cart"
                        >
                          View Cart
                        </Link>
                      </div>
                      <ul className="shopping-list">
                        {/* TODO:
                          Pull cart items data
                        */}
                        {cartItemsData.map((item) => (
                          <li key={item.slug}>
                            <button
                              className="remove"
                              title="Remove this item"
                              onClick={() => handleOnItemRemove(item.slug)}
                            >
                              <i className="fa-solid fa-xmark"></i>
                            </button>

                            <div className="cart-img-head">
                              <Link
                                className="cart-img"
                                to={"/product/" + item.slug}
                              >
                                <img
                                  // src={`${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/laderhack/products/${item.img}`}
                                  src={`../img/ProductImg2/${item.img}`}
                                  alt="#"
                                />
                              </Link>
                            </div>
                            <div className="content">
                              <h4>
                                <Link
                                  to={"/product/" + item.slug}
                                  style={{ textDecoration: "none" }}
                                  id="productName"
                                >
                                  {item.name}
                                </Link>
                              </h4>
                              <p className="quantity">
                                {item.quantity}x -{" "}
                                <span className="amount">${item.price}</span>
                              </p>
                            </div>
                          </li>
                        ))}
                      </ul>
                      <div className="bottom">
                        <div className="total">
                          <span>Total</span>
                          <span className="total-amount">
                            $
                            {cartItemsData
                              .reduce(
                                (prev, cur) => prev + cur.price * cur.quantity,
                                0
                              )
                              .toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
